export enum MaintenanceReportCategories {
    DataValidationReports = "Data Validation Reports",
    DataEnrichmentReports = "Data Enrichment Reports",
    DataExtractReports = "Data Extract Reports",
    SystemInformationReports = "System Information Reports"
};
